import { TyGiaQuyDoiNgoaiTe, TyGiaQuyDoiNgoaiTeInput } from '@/types/schemas';
import { ActionBar, ConfirmDialog, FormDialog } from './components';
import { useForms, useTyGiaQuyDoiNgoaiTe } from '@/hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { getDataTableColumns } from './cols-definition';

export default function DanhMucTyGiaQuyDoiNgoaiTe() {
  const { exchangeRates, isLoading, addExchangeRate, updateExchangeRate, deleteExchangeRate, refreshExchangeRates } =
    useTyGiaQuyDoiNgoaiTe();
  const {
    showForm,
    showDelete,
    formMode,
    isCopyMode,
    selectedObj,
    selectedRowIndex,

    handleCloseForm,
    handleCloseDelete,
    handleAddClick,
    handleEditClick,
    handleViewClick,
    handleDeleteClick,
    handleCopyClick,
    handleRowClick,
    clearSelection
  } = useForms<TyGiaQuyDoiNgoaiTe>();

  const tables = [
    {
      name: '',
      rows: exchangeRates,
      columns: getDataTableColumns()
    }
  ];

  const handleSubmit = async (data: TyGiaQuyDoiNgoaiTeInput) => {
    console.log('Submitting data:', data);
    try {
      if (formMode === 'add') {
        await addExchangeRate(data);
      } else if (formMode === 'edit' && selectedObj) {
        await updateExchangeRate(selectedObj.uuid, data);
      }

      handleCloseForm();
      clearSelection();
      await refreshExchangeRates();
    } catch (error) {
      console.error('Error submitting form:', error);
    }
  };
  return (
    <div className='flex h-full min-h-screen w-full min-w-0 max-w-full flex-col lg:overflow-hidden'>
      {showForm && (
        <FormDialog
          open={showForm}
          formMode={formMode}
          initialData={
            selectedObj && (formMode === 'edit' || formMode === 'view' || (formMode === 'add' && isCopyMode))
              ? selectedObj
              : formMode === 'add' && !isCopyMode
                ? undefined
                : undefined
          }
          onClose={handleCloseForm}
          onSubmit={handleSubmit}
          onAdd={() => {
            handleCloseForm();
            clearSelection();
            setTimeout(() => {
              handleAddClick();
            }, 100);
          }}
          onEdit={() => {
            if (selectedObj) {
              handleCloseForm();
              handleEditClick();
            }
          }}
          onDelete={() => {
            if (selectedObj) {
              handleCloseForm();
              handleDeleteClick();
            }
          }}
          onCopy={() => {
            if (selectedObj) {
              handleCloseForm();
              handleCopyClick();
            }
          }}
        />
      )}

      {showDelete && (
        <ConfirmDialog
          open={showDelete}
          onClose={handleCloseDelete}
          selectedObj={selectedObj}
          onDelete={deleteExchangeRate}
          clearSelection={clearSelection}
        />
      )}

      <div className='w-full'>
        <ActionBar
          onAddIconClick={handleAddClick}
          onEditIconClick={() => selectedObj && handleEditClick()}
          onDeleteIconClick={() => selectedObj && handleDeleteClick()}
          onCopyIconClick={() => selectedObj && handleCopyClick()}
          onWatchIconClick={() => selectedObj && handleViewClick()}
          hasRowSelected={!!selectedObj}
          onRefreshClick={refreshExchangeRates}
        />

        <ErpDataTableV2
          tables={tables}
          selectedRowId={selectedRowIndex || undefined}
          onRowClick={handleRowClick}
          loading={isLoading}
        />
      </div>
    </div>
  );
}
